module.exports = __webpack_public_path__ + "img/cubes.02296906.svg";